import { type InputLockingSpecs, nlAovqlSelectedDimension } from '@orus.eu/dimensions'

/**
 * `lockedDimension` is on for an nl-aovql quote only during the health review. Every input the customer writes in the
 * nl-aovql quote funnel takes this lock, or names `nlAovqlSelectedDimension` in its own client conditions, except the
 * payment recurrence, the partner promo code, the commercial messages consent, the nationality and the birth city.
 * Nothing checks that a new input does.
 */
export const nlAovqlClientInputLocking = {
  lockedInQuoteFor: { client: nlAovqlSelectedDimension },
} as const satisfies InputLockingSpecs
